import React from "react";
import { Link } from "react-router-dom";
import { buildExploreLocationPath } from "../utils";
import { cn } from "../../lib/utils";

/**
 * Whether a stored coordinate pair can open the explore map.
 * Matches the post location link: finite, and not the unset 0,0 default.
 *
 * @param {number|string|null|undefined} latitude
 * @param {number|string|null|undefined} longitude
 * @returns {boolean}
 */
function hasMapCoordinates(latitude, longitude) {
  const lat = Number(latitude);
  const lon = Number(longitude);
  return Number.isFinite(lat) && Number.isFinite(lon) && !(lat === 0 && lon === 0);
}

/**
 * Profile location or address. Opens the explore map when coordinates exist,
 * the same way a post location does.
 *
 * @param {Object} props
 * @param {string} props.label
 * @param {number|string|null|undefined} props.latitude
 * @param {number|string|null|undefined} props.longitude
 * @param {string} [props.className]
 * @param {React.ReactNode} [props.icon]
 * @returns {JSX.Element|null}
 */
function ProfileLocationLink({ label, latitude, longitude, className, icon = null }) {
  const text = typeof label === "string" ? label.trim() : "";
  if (!text) return null;

  const linked = hasMapCoordinates(latitude, longitude);
  const content = (
    <>
      {icon}
      <span className={cn("min-w-0 break-words", linked && "group-hover:underline")}>
        {text}
      </span>
    </>
  );

  if (!linked) {
    return <p className={className}>{content}</p>;
  }

  return (
    <Link
      to={buildExploreLocationPath(latitude, longitude, text)}
      className={cn(className, "group hover:text-accent")}
    >
      {content}
    </Link>
  );
}

export default ProfileLocationLink;
